import { jsxs as h, jsx as o } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import g from "@mui/material/CircularProgress";
import e from "styled-components";
import "../../theme/themes/AtriusDark.js";
import "../../theme/themes/AtriusLight.js";
import "../../theme/themes/DistechDark.js";
import "../../theme/themes/DistechLight.js";
import "../../theme/themes/DLNLight.js";
import "../../theme/utils/getThemeDefinition.js";
import { getFlavorColor as c } from "../../theme/utils/styleUtils.js";
import "../../theme/GlobalStyle.js";
import "@emotion/is-prop-valid";
import "@mui/material/styles";
import "lodash/merge";
import "color-convert";
const y = {
  root: "circularProgressRoot",
  circleDisableShrink: "circularProgressCircleDisableShrink"
}, u = e(g).withConfig({
  displayName: "StyledCircularProgress"
})([
  "&&.circularProgressRoot{color:",
  ";}&& .circularProgressCircleDisableShrink{stroke-dasharray:35px,100px;stroke-dashoffset:0px;}"
], ({ $flavor: r, theme: i }) => c(i, r)), C = e.div.withConfig({
  displayName: "Root"
})([
  "position:relative;display:inline-block;line-height:0px;"
]), k = e.div.withConfig({
  displayName: "Path"
})([
  "height:",
  "px;width:",
  "px;stroke:",
  ";display:inline-block;position:absolute;"
], ({ $size: r }) => r, ({ $size: r }) => r, ({ theme: r }) => r.primaryDisabled), P = e.circle.withConfig({
  displayName: "StyledCircle"
})([
  "opacity:0.15;stroke:",
  ";"
], ({ $flavor: r, theme: i }) => c(i, r)), x = /* @__PURE__ */ f(({ classes: r, disableShrink: i = !0, size: s = 40, thickness: n = 4, flavor: l = "normal", variant: a = "indeterminate", ...p }, m) => {
  const d = a === "indeterminate" ? i : !1, t = n ?? s / 10;
  return /* @__PURE__ */ h(C, {
    children: [
      /* @__PURE__ */ o(k, {
        $size: s,
        children: /* @__PURE__ */ o("svg", {
          viewBox: `${44 / 2} ${44 / 2} 44 44`,
          children: /* @__PURE__ */ o(P, {
            cx: 44,
            cy: 44,
            r: (44 - t) / 2,
            fill: "none",
            strokeWidth: t,
            $flavor: l
          })
        })
      }),
      /* @__PURE__ */ o(u, {
        "aria-label": "in progress",
        ...p,
        ref: m,
        classes: {
          ...y,
          ...r
        },
        disableShrink: d,
        thickness: t,
        color: "primary",
        $flavor: l,
        variant: a,
        size: s
      })
    ]
  });
});
x.displayName = "CircularProgress";
export {
  x as default
};
